// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { RemovedUserMenu } from './removed-user-menu'

const COMPONENT_ID = 'removedUserMenu'

interface Prop {
  roomId: string
  userId: string
}

export const showRemovedUserMenu = (props: Prop, preventBackClick = false) =>
  addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: RemovedUserMenu },
}
